import { render, staticRenderFns } from "./ChickenActivity.vue?vue&type=template&id=683610c2&scoped=true&"
import script from "./ChickenActivity.vue?vue&type=script&lang=js&"
export * from "./ChickenActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683610c2",
  null
  
)

export default component.exports